/*
* Scrolling
* https://codepen.io/techslides/pen/zowLd
*/
import { ZOOMSTATES } from './draw';
import * as createjs from 'createjs-module';

let touching = false;

export class DragAndDrop {

	element: any;
	startingPosition: {x: number, y: number};
	currentPosition: {x: number, y: number};
	children: any[];
	used: boolean;
	mouseIsDown: boolean;
	limit: number;
	limitMovement: boolean;
	active: boolean;
	isStatic: boolean;
	draw: any;

	constructor(element: any, isStatic: boolean, limit: number, limitMovement: boolean, draw?: any) {
		this.element = element;
		this.startingPosition = {x: 0, y: 0};
		this.currentPosition = {x: 0, y: 0};
		this.children = [];
		this.mouseIsDown = false;
		this.limit = limit;  // The border of the starting container
		this.limitMovement = limitMovement;
		this.draw = draw;
		this.active = false;
		this.isStatic = isStatic;

		this.setListeners();
	}

	setListeners(){
		if (!this.isStatic) {
			this.element.sprite.on('mousedown', (evt) => { this.mouseDown(evt, false); }).bind(this);
			this.element.sprite.on('pressmove', (evt) => { this.mouseMove(evt, false, false); }).bind(this);
			this.element.sprite.on('pressup', (evt) => { this.mouseUp(evt, false, false); }).bind(this);
		}
	}

	mouseDown (evt: any, carry: boolean) {
		console.log("MOUSE DOWN ", touching, "B", carry);
		if (!touching || carry) {
			touching = true;
			if(!carry)
				this.active = true;

			this.startingPosition.x = evt.stageX;
			this.startingPosition.y = evt.stageY;

			this.children.forEach((child) => child.mouseDown(evt, true));
		}
	}

	mouseMove(evt: any, carry: boolean, base: boolean) {
		if(this.active || carry){
			this.element.sprite.x = evt.stageX - this.startingPosition.x + this.currentPosition.x;
			this.element.sprite.y = evt.stageY - this.startingPosition.y + this.currentPosition.y;
			this.children.forEach((child) => child.mouseMove(evt, true));
		}
	}

	mouseUp(evt: any, carry: boolean, base: boolean) {
		if(this.active || carry){
			this.active = false;
			touching = false;

			if (evt.stageY > this.limit) {
				return;
			}

			this.currentPosition.x = evt.stageX - this.startingPosition.x + this.currentPosition.x;
			this.currentPosition.y = evt.stageY - this.startingPosition.y + this.currentPosition.y;

			this.children.forEach((child) => child.mouseUp(evt, true));
		}
	}

	transformIntoDrop(isReplay: boolean){
		return;
	}

	addChild(dragAndDrop: any) {
		if (!this.children.includes(dragAndDrop)) {
			this.children.push(dragAndDrop);
		}
	}

	removeChild(dragAndDrop: any) {
		const i = this.children.indexOf(dragAndDrop);
		if(i !== -1) {
			this.children.splice(i, 1);
		}
	}
}

export class SymbolDragAndDrop extends DragAndDrop {

	absoluteStartingPosition: {x: number, y: number};
	base: any;
	container: any;
	draw: any;
	drop: string;
	isDrop: boolean;

	constructor(element: any, startingPosition: any, container: any, base: any, limit: any, isStatic: boolean, draw: any, drop: string) {
		super(element, isStatic, limit, false, draw);
		this.absoluteStartingPosition = this.copy(startingPosition);
		this.startingPosition = this.copy(startingPosition);
		this.currentPosition = this.copy(startingPosition);
		this.container = container; // The parent drag and drop
		this.base = base;
		this.used = false;
		this.drop = drop;

		this.base.addChild(this);
	}

	mouseMove(evt: any, carry: boolean, base: boolean) {
		super.mouseMove(evt, true, base);
		if (this.element.sprite.y < this.limit && this.drop && !base) {
			this.transformIntoDrop(false);
		}
	}

	transformIntoDrop(isReplay: boolean){
		if(this.isDrop)
			return;

		this.isDrop = true;
		this.draw.stage.removeChild(this.element.sprite);
		
		this.element.sprite = new createjs.Bitmap(this.drop);
		this.element.sprite.scaleX = 0.5;
		this.element.sprite.scaleY = 0.5;
		this.element.sprite.alpha = 0.8;
		this.element.sprite.regX = 100;
		this.element.sprite.regY = 320;
		this.setListeners();

		this.draw.stage.addChild(this.element.sprite);
		this.draw.stage.removeChild(this.element.text);
		this.draw.repaintBase();
	}

	transformFromDrop(){
		if(!this.isDrop)
			return;
		this.isDrop = false;
		this.draw.stage.removeChild(this.element.sprite);

		this.element.sprite = new createjs.Bitmap(this.element.evaluation.image);
		this.element.sprite.scaleX = 0.5;
		this.element.sprite.scaleY = 0.5;
		this.element.sprite.alpha = 0.8;
		this.element.sprite.regX = 100;
		this.element.sprite.regY = 320;
		this.setListeners();

		this.draw.stage.addChild(this.element.sprite);
		this.draw.repaintBase();
	}

	mouseUp(evt: any, carry: boolean, base: boolean) {
		this.mouseIsDown = false;
		if (evt.stageY > this.limit) {
			touching = false;
			evt.target.x = this.currentPosition.x;
			evt.target.y = this.currentPosition.y;
		}else if(evt.stageY === 0) {
			super.mouseUp(evt, true, base);
			if(!base) {
				this.container.addChild(this);
				this.draw.repaintBase();
			}
		} else {
			super.mouseUp(evt, true, base);
			if(!base) {
				this.base.removeChild(this);
				this.container.addChild(this);
				this.used = true;

				this.draw.repaintBase();
			}
		}
	}

	copy(vector: any) {
		return {x: vector.x, y: vector.y};
	}
}

export class BaseDragAndDrop extends DragAndDrop{

	constructor(element: any) {
		super(element, false, 0, false);
		this.startingPosition = {x: 0, y: 0};
		this.currentPosition = {x: 0, y: 0};
	}

	setListeners(){
		this.element.sprite.on('mousedown', (evt) => { this.mouseDown(evt); }).bind(this);
		this.element.sprite.on('pressmove', (evt) => { this.mouseMove(evt); }).bind(this);
		this.element.sprite.on('pressup', (evt) => { this.mouseUp(evt); }).bind(this);
	}

	mouseDown (evt: any) {
		this.startingPosition.x = evt.stageX;
		evt.stageY = 0;
		this.children.forEach((child) => child.mouseDown(evt, true));
	}

	mouseMove(evt: any) {
		this.element.sprite.x = evt.stageX - this.startingPosition.x + this.currentPosition.x
		evt.stageY = 0;
		this.children.forEach((child) => child.mouseMove(evt, true, true));
		this.children.map(child => child.element).forEach(element => element.text.x = element.sprite.x - element.text.getBounds().width / 2);
	}

	mouseUp(evt: any) {
		this.currentPosition.x = evt.stageX - this.startingPosition.x + this.currentPosition.x
		evt.stageY = 0;
		this.children.forEach((child) => child.mouseUp(evt, true, true));
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Play/draganddrop.tsx